export const getTotalSelectionsAmount = (
  categoryTotalAmount: string,
  selectionTotalAmount: number,
  action: 'sum' | 'subtract'
) => {
  return action === 'subtract'
    ? (Number(categoryTotalAmount) - selectionTotalAmount).toFixed(2)
    : (Number(categoryTotalAmount) + selectionTotalAmount).toFixed(2);
};
